import type { Site } from '../Site';

export const WhatCulture: Site = {
  id: 'whatculture',
  analyticsName: 'whatculture',
  selector: 'a',
  logo: '',
  label: 'WhatCulture',
  platform: '',
};
